<template>
  <div class="New-members">
    <van-nav-bar left-arrow fixed placeholder @click-left="onClickLeft" v-show="!inpshow" ref="navBar">
      <template #right>
        <van-icon name="search" @click="inpshow = !inpshow" />
        <van-icon name="plus" v-show="!inpshow" @click="usershow = true" />
      </template>
      <template #title>
        新增会员
      </template>
    </van-nav-bar>
    <van-sticky v-show="inpshow" ref="searchDom">
      <van-search v-model="inpVal" show-action placeholder="请输入手机号搜索" @search="onSearch" @cancel="searchCancel"
        class="back-tran" />
    </van-sticky>
    <van-sticky :offset-top="navBarHeight">
      <div class="head">
        <div>手机号</div>
        <div class="name">姓名</div>
        <div>省份</div>
        <div>注册时间</div>
        <div>状态</div>
      </div>
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" offset="50">
      <div v-for="item in MemberList" :key="item.id" @click="getId(item.id)">
        <div class="list">
          <div>{{item.phone}}</div>
          <div>{{item.name}}</div>
          <div>{{item.province}}</div>
          <div class="time van-multi-ellipsis--l2">{{item.create_time}}</div>
          <div>{{item.new_user*1?'已对接':'未对接'}}</div>
        </div>
        <transition name="van-fade">
          <div class="operation" v-show="item.id === id">
            <div @click.stop="memberId = id;isShow = true">查看</div>
            <div @click.stop="memberId = id;dockingshow = true">添加对接记录</div>
            <div @click.stop="delese">删除</div>
          </div>
        </transition>
      </div>
    </van-list>
    <!-- 用户信息 -->
    <van-popup v-model="isShow" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <MemberInfo :memberId="memberId" @dockingshow='dockingshow = true' />
    </van-popup>
    <!-- 添加对接记录 -->
    <van-popup v-model="dockingshow" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <MemberAddRecord :memberId="memberId" @addRecoed="addRecoed()" />
    </van-popup>
    <!-- 添加用户 -->
    <van-popup v-model="usershow" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <MemberAdd :isUpdata="false" @addUser="usershow = false;onLoad(true)" />
    </van-popup>
  </div>
</template>

<script>
import MemberInfo from '@/components/memberInfo'
import MemberAddRecord from '@/components/memberAddRecord'
import MemberAdd from '@/components/memberAdd'
import { newMembers, delsteMember } from '@/api/member.js'
import delItem from '@/utils/delitem.js'
export default {
  name: 'newmembers',
  props: {},
  components: {
    MemberInfo,
    MemberAddRecord,
    MemberAdd
  },
  data () {
    return {
      MemberList: [],
      id: null,
      memberId: '',
      isShow: false, // 用户信息弹出层
      dockingshow: false, // 添加对接记录弹出层
      usershow: false, // 添加用户弹出层
      inpshow: false, // 搜索框展示隐藏
      inpVal: '', // 搜索内容
      searchVal: '', // 前一次搜索内容
      isSearch: false, // 判断要获取搜索数据还是所有数据
      loading: false,
      finished: false,
      page: 0,
      isData: false, // 是否停止加载 true：停止加载，false：继续加载
      navBarHeight: 44 // 头部高度
    }
  },
  watch: {
    inpshow (newVal) {
      this.getScrollTop()
    }
  },
  mounted () {
    this.getScrollTop()
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    // 获取头部顶部高度
    getScrollTop () {
      this.$nextTick(() => {
        if (this.inpshow) {
          this.navBarHeight = this.$refs.searchDom.$el.offsetHeight
        } else {
          this.navBarHeight = this.$refs.navBar.$el.offsetHeight
        }
      })
    },
    // 获取点击的会员ID
    getId (id) {
      if (this.id === id) {
        this.id = -1
      } else {
        this.id = id
      }
    },
    // 删除会员
    delese () {
      this.$dialog
        .confirm({
          title: '确认要删除吗?',
          confirmButtonColor: '#2DADB1'
        })
        .then(() => {
          this.shanchu()
        })
        .catch(() => {
          this.$dialog.close()
        })
    },
    async shanchu () {
      try {
        const data = await delsteMember(this.id)
        if (data.error_code === 1) {
          this.MemberList = delItem(this.MemberList, this.id)
          this.$toast('删除成功')
        } else {
          this.$toast('删除失败')
        }
      } catch (error) {
        return error.message
      }
    },
    // 加载列表
    async onLoad (type) {
      if (type) {
        this.MemberList = []
        this.page = 0
        this.loading = true
        this.finished = false
        this.isData = false
      }
      this.page += 1
      if (this.isSearch) {
        await this.getMember(this.page, this.searchVal)
      } else {
        await this.getMember(this.page)
      }
      await this.$delay(800)
      this.loading = false
      if (this.isData) {
        this.loading = false
        this.finished = true
      }
    },
    // 获取新增会员列表
    async getMember (page, searchVal) {
      try {
        const { data } = await newMembers(page, searchVal)
        this.MemberList = [...this.MemberList, ...data.userInfo]
        if (data.userInfo.length < 10) {
          this.isData = true
        }
      } catch (error) {
        this.isData = true
      }
    },

    // 搜索框展示/隐藏
    searchCancel () {
      this.inpshow = !this.inpshow
      if (this.searchVal) {
        this.id = -1
        this.searchVal = ''
        this.isSearch = false
        this.onLoad(true)
      }
    },
    // 回车搜索事件
    async onSearch (val) {
      if (val === '') {
        this.$toast('请输入搜索内容')
        return false
      }
      this.id = -1
      this.searchVal = val
      this.isSearch = true
      this.onLoad(true)
    },

    // 对接成功
    addRecoed () {
      this.dockingshow = false
      this.isShow = false
      this.MemberList = delItem(this.MemberList, this.id)
    }
  }
}
</script>

<style scoped lang="less">
.New-members {
  height: 100%;
  background-color: #fbfbfb;
  /deep/ .van-nav-bar {
    line-height: 88px;
  }
  /deep/ .van-popup {
    background-color: #f8f8f8;
  }
  /deep/ .van-icon-search,
  /deep/ .van-icon-plus {
    font-size: 40px;
    color: #2dadb1 !important;
    font-weight: 700;
  }
  /deep/ .van-icon-plus {
    padding-left: 48px;
  }
  .inp {
    width: 432px;
    height: 60px;
    background: rgba(243, 242, 242, 1);
    border-radius: 30px;
    padding-left: 30px;
    box-sizing: border-box;
    margin-bottom: 14px;
  }
  .head {
    display: flex;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: rgba(45, 173, 177, 1);
    justify-content: space-around;
    div {
      font-size: 26px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .name {
      padding-left: 40px;
    }
  }
  .list {
    display: flex;
    justify-content: space-between;
    width: 702px;
    height: auto;
    line-height: 100px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin: 20px auto;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
    padding: 10px;
    box-sizing: border-box;
    .time {
      width: 140px;
    }
  }
  .operation {
    display: flex;
    width: 702px;
    height: 80px;
    line-height: 80px;
    background: rgba(45, 173, 177, 1);
    justify-content: space-around;
    margin: 0 auto;
    margin-top: -20px;
    div {
      font-size: 26px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
  /deep/ .van-popup--bottom {
    width: 95%;
    left: 18px;
  }
  /deep/ .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
}
</style>
